// Self-registering plugin: Tools → Proxy Customer page.
import ProxyCustomerPage from './components/ProxyCustomerPage.vue';

export const PROXY_CUSTOMER_ROUTE = 'custom_proxy_customer';

export const installProxyCustomer = ({ router }) => {
  if (!router || router.hasRoute(PROXY_CUSTOMER_ROUTE)) return;

  const route = {
    name: PROXY_CUSTOMER_ROUTE,
    path: '/app/accounts/:accountId/custom/proxy-customer',
    component: ProxyCustomerPage,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  };

  if (router.hasRoute('app_container')) {
    router.addRoute('app_container', route);
  } else {
    router.addRoute(route);
  }
};

export default installProxyCustomer;
